import { useNavigate } from 'react-router-dom';
import { useI18n } from '@/i18n';
import { Button } from '@/components/ui/button';
import { FaCircleArrowLeft } from "react-icons/fa6";
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

export function HelpCenter() {
  const { currentLang } = useI18n();
  const navigate = useNavigate();

  const faqs = [
    {
      q: currentLang === 'bn' ? 'কিভাবে অর্ডার করবো?' : 'How do I place an order?',
      a: currentLang === 'bn' 
        ? 'আপনার পছন্দের পণ্য কার্টে যোগ করে চেকআউট করুন। ক্যাশ অন ডেলিভারি বা অনলাইন পেমেন্টের মাধ্যমে মূল্য পরিশোধ করতে পারবেন।' 
        : 'Add your favorite products to the cart and proceed to checkout. You can pay via Cash on Delivery or online payment.'
    },
    {
      q: currentLang === 'bn' ? 'ডেলিভারি হতে কত সময় লাগে?' : 'How long does delivery take?',
      a: currentLang === 'bn' 
        ? 'সাধারণত ঢাকার ভেতর ২৪ ঘন্টা এবং ঢাকার বাইরে ২-৩ দিন সময় লাগে।' 
        : 'Usually it takes 24 hours inside Dhaka and 2-3 days outside Dhaka.'
    },
    {
      q: currentLang === 'bn' ? 'ডেলিভারি চার্জ কত?' : 'What is the delivery charge?',
      a: currentLang === 'bn' 
        ? 'শিপিং চার্জ আপনার এলাকার উপর নির্ভর করে চেকআউটের সময় নির্ধারণ করা হয়।' 
        : 'Shipping charge is calculated at checkout based on your delivery area.'
    }
  ];

  return (
    <div className="min-h-[100dvh] bg-gray-50 font-sans pb-32 lg:pb-10">
      <header className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-xl border-b border-gray-100/50 shadow-[0_4px_20px_rgba(0,0,0,0.03)] transition-all">
        <div className="max-w-2xl mx-auto px-4 py-4 flex items-center justify-between">
          <Button
            variant="ghost"
            size="icon"
            className="rounded-xl hover:bg-gray-50 text-black transition-all active:scale-95"
            onClick={() => navigate(-1)}
          >
            <FaCircleArrowLeft className="h-6 w-6" />
          </Button>
          <h1 className="text-lg font-black tracking-tight text-center flex-1">
            {currentLang === 'bn' ? 'হেল্প সেন্টার' : 'Help Center'}
          </h1>
          <div className="w-10" /> {/* Spacer */}
        </div>
      </header>

      <div className="container mx-auto px-4 max-w-lg mt-6 space-y-6">
        
        {/* Contact Support */}
        <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100">
          <h2 className="text-lg font-bold text-black mb-4">
            {currentLang === 'bn' ? 'যোগাযোগ করুন' : 'Contact Support'}
          </h2>
          <div className="space-y-4">
            <a href="tel:+8801234567890" className="flex items-center gap-4 bg-gray-50 p-4 rounded-2xl hover:bg-primary/5 transition-colors">
              <div className="w-10 h-10 bg-primary/10 text-primary rounded-full flex items-center justify-center">
                <FaPhoneAlt />
              </div>
              <div>
                <p className="text-xs text-gray-500 font-medium">Hotline</p>
                <p className="font-bold text-black">+880 1234 567 890</p>
              </div>
            </a>
            <a href="mailto:support@chocolatevibes.com" className="flex items-center gap-4 bg-gray-50 p-4 rounded-2xl hover:bg-primary/5 transition-colors">
              <div className="w-10 h-10 bg-primary/10 text-primary rounded-full flex items-center justify-center">
                <FaEnvelope />
              </div>
              <div>
                <p className="text-xs text-gray-500 font-medium">Email Support</p>
                <p className="font-bold text-black">support@chocolatevibes.com</p>
              </div>
            </a>
          </div>
        </div>

        {/* FAQs */}
        <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100">
          <h2 className="text-lg font-bold text-black mb-4">
            {currentLang === 'bn' ? 'সাধারণ জিজ্ঞাসা (FAQ)' : 'Frequently Asked Questions'}
          </h2>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="border-b border-gray-100 pb-4 last:border-0 last:pb-0">
                <h3 className="font-bold text-black text-sm mb-1">{faq.q}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
